import { A } from "@solidjs/router"
import { cn } from "@/utilities/cn"
import { Cards } from "../components/Cards";

export default function StuffView() {
  return (
    <div class="flex flex-col p-4 gap-4 overflow-y-auto">
      <h1 class="text-2xl font-bold">Stuff</h1>
      <Cards />
    </div>
  );
}
